import { render, staticRenderFns } from "./ImgFormMulti.vue?vue&type=template&id=58d98bce&"
import script from "./ImgFormMulti.vue?vue&type=script&lang=js&"
export * from "./ImgFormMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports